import { InteractionInterface } from './InteractionInterface';
import graphicChoiceRender from '../components/interactions/graphicChoiceRender.vue';

export class graphicChoiceInteraction extends InteractionInterface {
  constructor(question, testData) {
    super(question);
    this.testData = testData;
    this.userAnswer = {
      clickedZones: [],
      score: 0,
      hintUsed: false,
      timestamp: null
    };
  }

  render() {
    return {
      component: graphicChoiceRender,
      props: {
        question: this.question,
        testData: this.testData,
        restoredAnswer: this.userAnswer,
      },
    };
  }

  restoreAnswer(savedAnswer) {
    if (savedAnswer) {
      this.userAnswer = {
        clickedZones: savedAnswer.clickedZones || [],
        score: savedAnswer.score || 0,
        hintUsed: savedAnswer.hintUsed || false,
        timestamp: savedAnswer.timestamp || null
      };
    }
  }

  calculateScore(userAnswer) {
    // userAnswer structure: { clickedZones: string[], hintUsed: boolean }
    if (!userAnswer || !userAnswer.clickedZones) {
      return 0;
    }

    const zones = this.question.el_Data || [];
    const correctZones = zones.filter(z => z.isCorrect);
    const clickedZoneIds = userAnswer.clickedZones;

    // Calculate points from correctly clicked zones
    const correctClicks = clickedZoneIds.filter(zoneId =>
      correctZones.some(z => z.id === zoneId)
    );

    const score = correctClicks.reduce((sum, zoneId) => {
      const zone = zones.find(z => z.id === zoneId);
      return sum + (zone?.score || 0);
    }, 0);

    // Calculate penalties for incorrectly clicked zones
    const incorrectClicks = clickedZoneIds.filter(zoneId =>
      !correctZones.some(z => z.id === zoneId)
    );

    const penalties = incorrectClicks.reduce((sum, zoneId) => {
      const zone = zones.find(z => z.id === zoneId);
      return sum + (zone?.penalty || 0);
    }, 0);

    // Final score cannot be negative
    const finalScore = Math.max(0, score - penalties);

    // Apply hint penalty if configured (optional: reduce score by 10% if hint used)
    // const hintPenalty = userAnswer.hintUsed ? finalScore * 0.1 : 0;
    // return Math.max(0, finalScore - hintPenalty);

    return finalScore;
  }

  saveAnswer() {
    return this.userAnswer;
  }

  // Additional helper method to validate answer completeness
  isAnswerComplete(userAnswer) {
    if (!userAnswer || !userAnswer.clickedZones) {
      return false;
    }

    // In single mode, at least one zone must be clicked
    // In multiple mode, at least one zone must be clicked
    return userAnswer.clickedZones.length > 0;
  }

  // Helper method to get detailed scoring breakdown
  getScoreBreakdown(userAnswer) {
    if (!userAnswer || !userAnswer.clickedZones) {
      return {
        correctClicks: 0,
        incorrectClicks: 0,
        score: 0,
        penalties: 0,
        finalScore: 0
      };
    }

    const zones = this.question.el_Data || [];
    const correctZones = zones.filter(z => z.isCorrect);
    const clickedZoneIds = userAnswer.clickedZones;

    const correctClicks = clickedZoneIds.filter(zoneId =>
      correctZones.some(z => z.id === zoneId)
    );

    const incorrectClicks = clickedZoneIds.filter(zoneId =>
      !correctZones.some(z => z.id === zoneId)
    );

    const score = correctClicks.reduce((sum, zoneId) => {
      const zone = zones.find(z => z.id === zoneId);
      return sum + (zone?.score || 0);
    }, 0);

    const penalties = incorrectClicks.reduce((sum, zoneId) => {
      const zone = zones.find(z => z.id === zoneId);
      return sum + (zone?.penalty || 0);
    }, 0);

    return {
      correctClicks: correctClicks.length,
      incorrectClicks: incorrectClicks.length,
      score,
      penalties,
      finalScore: Math.max(0, score - penalties)
    };
  }
}
